import { jsx as _jsx } from "react/jsx-runtime";
import './TS_ListOrganizer.scss';
import { LL_V_L } from '../Layouts/index.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { exists, swapInArrayByIndex } from '@nu-art/ts-common';
export class TS_ListOrganizer extends ComponentSync {
    draggedItemIndex = undefined;
    lockRowIndex = undefined;
    activeDrag = undefined;
    //######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        state.items = [...nextProps.items];
        return state;
    }
    //######################### Logic #########################
    onDragStart = (e, rowIndex) => {
        e.stopPropagation();
        this.draggedItemIndex = rowIndex;
        this.activeDrag = true;
        this.forceUpdate();
    };
    onDragOver = (e, rowIndex) => {
        e.stopPropagation();
        if (rowIndex === this.lockRowIndex)
            return;
        if (!this.activeDrag)
            return;
        if (!exists(this.draggedItemIndex) || this.draggedItemIndex === rowIndex)
            return;
        swapInArrayByIndex(this.state.items, rowIndex, this.draggedItemIndex);
        this.lockRowIndex = this.draggedItemIndex;
        this.draggedItemIndex = rowIndex;
        this.forceUpdate();
    };
    onDragEnd = (e) => {
        e.stopPropagation();
        this.draggedItemIndex = undefined;
        this.lockRowIndex = undefined;
        this.activeDrag = undefined;
        this.forceUpdate(() => this.props.onOrderChanged(this.state.items));
    };
    onDragLeave = (e, rowIndex) => {
        e.stopPropagation();
        if (!this.activeDrag)
            return;
        if (rowIndex === this.lockRowIndex)
            this.lockRowIndex = undefined;
    };
    //######################### Render #########################
    render() {
        return _jsx(LL_V_L, { className: 'ts-list-organizer__list', children: this.state.items.map((item, itemIndex) => {
                const dragged = itemIndex === this.draggedItemIndex;
                return this.props.renderer({
                    item,
                    dragged,
                    index: itemIndex,
                    onDragEnd: this.onDragEnd,
                    onDragOver: this.onDragOver,
                    onDragLeave: this.onDragLeave,
                    onDragStart: this.onDragStart,
                });
            }) });
    }
}
//# sourceMappingURL=TS_ListOrganizer.js.map